export const starWarsApiBaseUrl = 'https://swapi.dev/api/'
